import axios from 'axios'
import Qs from 'qs'
import {Toast} from '@nutui/nutui';
import router from '@/router'


let baseURL = ''
//配置开发环境
if (process.env.NODE_ENV === 'development') {
    baseURL = '/stage-api';
}
 
// 配置生产环境
if (process.env.NODE_ENV === 'production') {
  baseURL = '/stage-api';
}

const instance = axios.create({
	timeout: 1800000
})

instance.interceptors.request.use(config => {
	const token = localStorage.getItem('token')
	if (token) {
		config.headers['authorization'] = token
	}
	return config
})

instance.interceptors.request.use((config)=>{
	if(!config.headers['Content-Type']){
	  config.headers['Content-Type'] = 'application/json'
	}
	config.headers['Client-Type'] = 'H5'
	config.headers['Client-App'] = 'MERCHANT'
	return config
})

instance.interceptors.response.use((res)=>{
	if (res.data.code) {
	  let code = res.data.code
	  if (code == '401') { // 认证失败
	    localStorage.removeItem('user')
		let url = window.location.href.split('#')[1]
		if(url != '/login'){
			sessionStorage.setItem('redirectPath',url)
		}
	    router.push('/login')
	  }
	  if(code != 200){
		  Toast.fail(res.data.msg)
	  }
	}
	return res
})
const api = { 
	baseURL,
	getCodeImg(params) {//获取图形码
		return instance.get(`${baseURL}/code`, {params: params})
	},
	login(params) {//登录
		return instance.post(`${baseURL}/auth/login`, params)
	},
	updatePwd(params) {//登录
		return instance.put(`${baseURL}/system/user/profile/updatePwd`, params)
	},
	getInfo(params) {//获取用户信息
		return instance.get(`${baseURL}/system/user/getInfo`, {params: params})
	},
	overview(id) {//首页订单统计
		return instance.get(`${baseURL}/factor/aggregation/dashboard/overview/${id}`)
	},
	merchantStatistics(id) {//首页商户统计
		return instance.get(`${baseURL}/factor/aggregation/dashboard/merchantStatistics/${id}`)
	},
	applicationList(params) {//获取列表
		return instance.get(`${baseURL}/factor/application/list`, {params: params})
	},
	orderList(params) {//获取列表
		return instance.get(`${baseURL}/factor/order/list`, {params: params})
	},
	getDict(type) {//获取字典项
		return instance.get(`${baseURL}/system/dict/data/type/${type}`)
	},
	instance: instance

}
export default api